import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CImg,
} from "@coreui/react";

// sidebar nav config
import navigation from "./_nav";
import { useState } from "react";
import qc_logo from "src/assets/images/qclogo_main.png";
import dpos_logo from "src/assets/images/dpos_logo.png";
import { storeUserInterfaceInfo } from "src/actions/uiAction";

const TheSidebar = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const { sidebar, showSideBar } = useSelector((state) => state.ui);
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    function loadRoles() {
      if (user.profile.Permission.length) {
        let menu = navigation(user.profile.role).map((p) => {
          let m = { ...p };
          
          if (m._children) {
            const m_submenu = m._children.filter(
              (s) =>
                user.profile.Permission.indexOf(s.permission) > -1 ||
                s.name.toLowerCase() === "user account" || m.name === "Dashboard"
            );
            
            m._children = m_submenu;

            if (m._children.length === 0) {
              return null;
            }
          }

          return m;
        });

        menu = menu.filter((p) => p !== null);

        menu = menu.filter(
          (p) =>
            user.profile.Permission.indexOf(p.permission) > -1 ||
            p.permission === undefined
        );

        setNavItems(menu);
      }
    }

    if (user) {
      loadRoles();
    }
  }, [user]);

  return (
    <CSidebar
      show={sidebar}
      unfoldable
      onShowChange={(val) => {
        dispatch(
          storeUserInterfaceInfo({
            sidebar: val === "responsive" ? false : true,
          })
        );
      }}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        <CImg
          src={dpos_logo}
          className="mr-3 c-sidebar-brand-full"
          style={{
            width: "40px",
          }}
        />
        <CImg
          src={qc_logo}
          className="c-sidebar-brand-full"
          style={{
            width: "40px",
          }}
        />
        {/* <CIcon
          className="c-sidebar-brand-full"
          name="logo-negative"
          height={35}
        />
        <CIcon
          className="c-sidebar-brand-minimized"
          name="sygnet"
          height={35}
        /> */}
        {/*<h1>OVR</h1>*/}
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navItems}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
